// @flow

import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "@components";
import SystemAccessEmailsGrid from "./emails-grid";

type OwnProps = $Exact<{
  ...PropsFromLocalize,
  onCancel: () => void,
  onSubmit: (form: Object) => void,
  bulkRegistrationEmailTargets: ?number,
}>;

const BulkRegistrationEmailsExportModal = (props: OwnProps) => {
  return (
    <Modal>
      <ModalHeader toggle={props.onCancel} className="d-flex justify-content-between">
        {props.t("REVIEW_BULK_REGISTRATION_ADDRESSES")}
      </ModalHeader>
      <ModalBody>
        <SystemAccessEmailsGrid />
      </ModalBody>
      <ModalFooter className="d-flex justify-content-end">
        <Button color="secondary" onClick={props.onCancel}>
          {props.t("CANCEL")}
        </Button>
        <Button materialIcon="file_download" onClick={props.onSubmit}>
          {props.t("EXPORT")}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default BulkRegistrationEmailsExportModal;
